import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.css';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FC } from 'react';

const OthersCalculating: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.controls}>
        <div className={styles.textContainer}>
          <FontAwesomeIcon icon={faSpinner} className={styles.icSpinner} />
          <span className={styles.controlText}>
            他の人が計算を実行中です...
          </span>
        </div>
      </div>
      <div className={styles.loadbarContainer}>
        <div className={styles.loadbar}></div>
      </div>
    </div>
  );
};
export default OthersCalculating;
